import { QuestionCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useViewport } from "../../../../hooks/useViewport";
import { StatusIcon, iconInkByKey, type RowStatusKey } from "./OrderItemRow";

// „?" в края на първия батч разделител — легенда какво значи всяка
// статус-иконка на редовете. Десктоп: панелът се показва на hover (само
// Tailwind hover:, без JS). Телефон/таблет: отваря се с клик; backdrop и
// Esc (с preventDefault — иначе Esc навигира и „назад") я затварят.
export const StatusLegendHint = () => {
  const { t } = useTranslation();
  const { isDesktop } = useViewport();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        // preventDefault = „Esc е консумиран" за глобалната Esc-навигация
        e.preventDefault();
        setOpen(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const entries: Array<[RowStatusKey, string]> = [
    ["none", t("ordering.statusNotStarted")],
    ["progress", t("ordering.statusInProgress")],
    ["ready", t("ordering.statusCooked")],
    ["issued", t("ordering.statusIssued")],
    ["served", t("ordering.servedStatus")],
  ];

  const panel = (
    <div className="dk-elevated bg-pos-card border border-pos-line rounded-[12px] p-2.5 flex flex-col gap-1.5 w-max shadow-[0_16px_40px_rgba(60,40,20,.16)]">
      {entries.map(([statusKey, label]) => (
        <div key={statusKey} className="flex items-center gap-2">
          <span
            className={`grid place-items-center ${iconInkByKey[statusKey]}`}
          >
            <StatusIcon statusKey={statusKey} />
          </span>
          <span className="text-[13px] font-semibold text-pos-ink2">
            {label}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <span className="relative shrink-0 group">
      <button
        type="button"
        aria-label={t("ordering.statusLegend")}
        onClick={isDesktop ? undefined : () => setOpen((value) => !value)}
        className={`border-0 bg-transparent p-0 grid place-items-center text-pos-dim hover:text-pos-soft ${
          isDesktop ? "cursor-default" : "cursor-pointer"
        }`}
      >
        <QuestionCircleOutlined className="text-[17px]" />
      </button>

      {isDesktop ? (
        /* pt-1.5 е в обвивката, за да няма „дупка" между бутона и панела
           и hover-ът да не прекъсва по пътя */
        <span className="hidden group-hover:block absolute right-0 top-full pt-1.5 z-40">
          {panel}
        </span>
      ) : (
        open && (
          <>
            {/* Backdrop — клик извън панела го затваря */}
            <span
              className="fixed inset-0 z-30"
              onClick={() => setOpen(false)}
            />
            <span className="absolute right-0 top-[calc(100%+6px)] z-40 block">
              {panel}
            </span>
          </>
        )
      )}
    </span>
  );
};
